import styled, { css } from "styled-components";
type GroupStyledProps = {
  $width: string;
  $mobileOrder: number | null;
  $comboMobileMediaWidth?: number;
};

export const GroupStyled = styled.div<GroupStyledProps>`
  width: ${({ $width = "100" }) => `${$width}%`};

  ${({ $mobileOrder }) =>
    $mobileOrder &&
    css`
      @media screen and (max-width: 768px) {
        order: ${$mobileOrder};
      }
    `};
`;
